module.exports = __webpack_public_path__ + "img/feature_sy.effa9648.gif";